import React, { useMemo } from 'react'
import classnames from 'classnames'
import { useLocalization } from '@/hooks/localization'
import { getCellStyles } from './utils'

function LinkSoftTableColHeaderCell (props) {
  const {
    isCurrentCol,
    columnSizes,
    headerRenderer,
    ...metadata
  } = props
  const {
    className,
    colSpan,
    rowSpan,
    depth,
    value,
    xCoord,
    yCoord
  } = metadata

  const { rtl } = useLocalization()
  const style = useMemo(() => getCellStyles(metadata, columnSizes, rtl), [columnSizes, metadata, rtl])
  const finalClassName = classnames(className, 'table-cell', 'htDimmed', 'ht_colDepth-' + depth, {
    'table-column--current': isCurrentCol
  })
  const HeaderRenderer = headerRenderer
  const content = HeaderRenderer ? <HeaderRenderer {...metadata} /> : value
  const Cell = 'div'
  return <Cell
    style={style} className={finalClassName}
    colSpan={colSpan} rowSpan={rowSpan}
    title={value}
    data-x={xCoord} data-y={yCoord}
  >
    <div className='table-cell-content'>{content}</div>
  </Cell>
}

export {
  LinkSoftTableColHeaderCell
}



// WEBPACK FOOTER //
// ./src/components/report-tables/core/colHeaderCell.js